import React, { useState } from "react";
import Stats from "./Stats.jsx";
import PageHeader from "./PageHeader.jsx";

export default function Profile({ user, logout }) {
  const [gender, setGender] = useState(user.gender || "");
  const [code, setCode] = useState(user.code || "");
  const [saved, setSaved] = useState(false);

  const save = async (gender) => {
    setGender(gender);
    await fetch('/api/user/gender', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ gender })
    });
    user.gender = gender;

    // Force a re-render of the parent App component by dispatching a custom event
    window.dispatchEvent(new CustomEvent('userGenderChanged', { detail: { gender } }));
  };

  const saveCode = async () => {
    await fetch('/api/user/code', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ code })
    });
    user.code = code;
    setSaved(true);
    setTimeout(() => setSaved(false), 2000);
  };

  return (
    <div className="page profile-page">
      <PageHeader
        title={`Welcome, ${user.username}! 👋`}
        description="Your baby name journey dashboard. Track your progress and manage your preferences."
      />

      <div className="card-grid">
        <div className="card">
          <h3>👶 Baby Gender</h3>
          <p>Help us suggest the perfect names for your little one.</p>
          <div className="button-group">
            {['male', 'female', 'neutral'].map(g => (
              <button
                key={g}
                className={gender === g ? 'btn-primary' : 'btn-secondary'}
                onClick={() => save(g)}
              >
                {g === 'male' ? '👦 Boy' : g === 'female' ? '👧 Girl' : '⚖️ Neutral'}
              </button>
            ))}
          </div>
        </div>

        <div className="card">
          <h3>🚪 Account</h3>
          <p>Control your account settings.</p>
          <button
            className="btn-outline"
            onClick={logout}
            style={{ width: '100%' }}
          >
            Log Out
          </button>
          <div className="code-card">
            <h3 className="code-title">🔐 Share Code</h3>
            <p>Give this code to friends so they can see your list.</p>
            <input
              placeholder="Set a secret code"
              value={code}
              onChange={e => setCode(e.target.value)}
              style={{ marginBottom: '1rem', width: '100%' }}
            />
            <button className="btn-secondary" onClick={saveCode} style={{ width: '100%' }}>
              Save Code
            </button>
            {saved && (
              <div className="save-confirmation">Code saved!</div>
            )}
          </div>
        </div>
      </div>

      <Stats user={user} />
    </div>
  );
}
